export enum ReportFilterSchemas {
  Basic = 'http://powerbi.com/product/schema#basic',
  Advanced = 'http://powerbi.com/product/schema#advanced',
  VisualSelector = 'http://powerbi.com/product/schema#visualSelector',
}
